import type { Inbox } from '../../core/types/adminRequests'
import { isToPack } from '../inbox/inboxRules'

/**
 * Wat er in de Inbox op Sarah wacht. Eén bron voor het getal in het menu (useNavCounts) en de
 * lijst op het overzicht (useAttention), zodat die twee nooit iets anders zeggen.
 */
export function inboxWaiting(inbox: Inbox) {
  const toPack = inbox.orders.filter(isToPack)
  // Een gekochte kuur die niet vanzelf aan een klant hing: Sarah legt hem vast in het dossier.
  const kuurToLink = inbox.orders.filter((o) => o.kuurToLink && !toPack.includes(o))
  const bookingRequests = inbox.bookings.filter((b) => b.status === 'aanvraag')
  return { toPack, kuurToLink, bookingRequests, total: toPack.length + kuurToLink.length + bookingRequests.length }
}
